import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface StoreHoursUpdateSuccessProps extends BaseTemplateProps {
  retailerName: string
}

export const StoreHoursUpdateSuccess: TemplateDefinition<StoreHoursUpdateSuccessProps> = {
  renderParams: (props: StoreHoursUpdateSuccessProps) => ({
    messageKey: 'notificationsDomain.templates.storeHoursUpdateSuccess',
    values: {
      retailerName: props.retailerName,
    },
  }),
}
